export interface ProgressiveAudioTimelineSegment {
  index: number;
  startSeconds: number;
  durationSeconds: number;
}

export function findProgressiveSegmentAtTime(
  segments: ProgressiveAudioTimelineSegment[],
  requestedTime: number,
  availableDuration: number,
) {
  if (!Number.isFinite(requestedTime) || !Number.isFinite(availableDuration) || !segments.length) return null;
  const time = Math.max(0, Math.min(availableDuration, requestedTime));
  return segments.find(segment =>
    Number.isSafeInteger(segment.index) &&
    Number.isFinite(segment.startSeconds) && segment.startSeconds >= 0 &&
    Number.isFinite(segment.durationSeconds) && segment.durationSeconds > 0 &&
    time >= segment.startSeconds && time < segment.startSeconds + segment.durationSeconds,
  ) || (time >= availableDuration ? segments[segments.length - 1] : null);
}

export function nextProgressiveSegment(
  segments: ProgressiveAudioTimelineSegment[],
  currentIndex: number,
) {
  return segments.find(segment => segment.index > currentIndex) || null;
}

export function globalProgressiveTime(segment: ProgressiveAudioTimelineSegment, localSeconds: number) {
  const local = Number.isFinite(localSeconds) ? Math.max(0, Math.min(segment.durationSeconds, localSeconds)) : 0;
  return Math.max(0, segment.startSeconds + local);
}

export function pcm24kMonoToWav(pcm: ArrayBuffer) {
  const bytes = new Uint8Array(pcm);
  const wav = new ArrayBuffer(44 + bytes.byteLength);
  const view = new DataView(wav);
  const write = (offset: number, value: string) => {
    for (let index = 0; index < value.length; index++) view.setUint8(offset + index, value.charCodeAt(index));
  };
  write(0, 'RIFF');
  view.setUint32(4, 36 + bytes.byteLength, true);
  write(8, 'WAVE');
  write(12, 'fmt ');
  view.setUint32(16, 16, true);
  view.setUint16(20, 1, true);
  view.setUint16(22, 1, true);
  view.setUint32(24, 24_000, true);
  view.setUint32(28, 48_000, true);
  view.setUint16(32, 2, true);
  view.setUint16(34, 16, true);
  write(36, 'data');
  view.setUint32(40, bytes.byteLength, true);
  new Uint8Array(wav, 44).set(bytes);
  return new Blob([wav], { type: 'audio/wav' });
}
